module.exports = __webpack_public_path__ + "static/media/m-rabbitAlchemist.aadfc4f5.png";